import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <div className="w-full max-w-sm">
        <h2 className="font-heading text-2xl font-bold tracking-tight text-slate-900">
          Reset password
        </h2>
        {done ? (
          <p data-testid="forgot-confirmation" className="text-sm text-slate-600 mt-4">
            If that email is registered, a reset link has been sent. Check your inbox.
          </p>
        ) : (
          <>
            <p className="text-sm text-slate-500 mt-1 mb-6">
              Enter your email and we'll send a reset link.
            </p>
            <form onSubmit={submit} className="space-y-4">
              <div className="space-y-1.5">
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email"
                  type="email"
                  data-testid="forgot-email-input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              {error && <p className="text-sm text-destructive">{error}</p>}
              <Button
                type="submit"
                data-testid="forgot-submit-button"
                disabled={loading}
                className="w-full bg-primary hover:bg-slate-800 rounded-full h-11"
              >
                {loading ? "Sending…" : "Send reset link"}
              </Button>
            </form>
          </>
        )}
        <div className="mt-4 text-center">
          <Link to="/login" className="text-sm text-accent hover:underline">
            Back to sign in
          </Link>
        </div>
      </div>
    </div>
  );
}
